import type { pilots as en } from '@/i18n/locales/en/pilots';
import type { Translation } from '@/i18n/types';

export const pilots: Translation<typeof en> = {
  page: {
    title: 'Pilot',
    lead: 'Pilot in corso presso {{company}}.',
    noScope: "Seleziona un'azienda per vedere i suoi pilot.",
    listTitle: 'Pilot',
    empty: 'Nessun pilot ancora.',
  },
  status: {
    draft: 'Bozza',
    baseline: 'Misurazione iniziale',
    active: 'Attivo',
    interim_review: 'Valutazione intermedia',
    final_review: 'Valutazione finale',
    completed: 'Completato',
    scaled: 'Esteso',
  },
  phases: {
    baseline: 'Misurazione iniziale',
    interim: 'Valutazione intermedia',
    final: 'Valutazione finale',
  },
  kpis: {
    participationRate: 'Tasso di partecipazione',
    activeUsers: 'Utenti attivi',
    dailyUsage: 'Utilizzo giornaliero',
    satisfaction: 'Soddisfazione dei dipendenti',
    avgVitality: 'Vitalità media',
    aiCoachUsage: 'Utilizzo AI coach',
    challengeUsage: 'Utilizzo challenge',
    rolloutReadiness: 'Raccomandazione di estensione',
  },
  form: {
    title: 'Nuovo pilot',
    name: 'Nome',
    startDate: 'Data di inizio',
    departments: 'Reparti',
    submit: 'Crea pilot',
  },
  detail: {
    title: 'Pilot',
    lead: 'Valutazione del pilot sulla vitalità con KPI, tendenze, conclusioni e una decisione di estensione motivata.',
    exportPdf: 'Esporta report (PDF)',
    hero: {
      badge: {
        success: 'Pilot riuscito',
        partial: 'Pilot in corso',
        atRisk: 'Attenzione richiesta',
        pending: 'Pilot in esecuzione',
      },
      goals: {
        success: 'Tutti gli obiettivi KPI raggiunti',
        partial: 'Alcuni obiettivi KPI raggiunti',
        atRisk: 'Obiettivi KPI non ancora raggiunti',
        pending: 'Dati non ancora sufficienti per una raccomandazione',
      },
      headlinePrefix: {
        success:
          'Il pilot dimostra che NOLATR Fit migliora in modo misurabile la vitalità — raccomandazione:',
        partial: 'Il pilot mostra un miglioramento — raccomandazione:',
        atRisk: 'Il pilot non mostra ancora un miglioramento misurabile — raccomandazione:',
        pending:
          'Non ci sono ancora dati sufficienti per una raccomandazione su come procedere con',
      },
      headlineAdvice: {
        success: "estendere a tutta l'organizzazione.",
        partial: 'prolungare il pilot per ottenere più dati.',
        atRisk: 'correggere questo aspetto prima di estendere.',
        pending: "l'estensione.",
      },
    },
    summary: {
      participation: 'Partecipazione',
      dailyActive: 'Attivi quotidianamente',
      stress: 'Stress',
      sleep: 'Sonno',
      goal: 'obiettivo {{value}}%',
      vsBaseline: 'vs. misurazione iniziale',
      minutes: '{{value}} min',
    },
    aiSummaryTitle: 'Riepilogo IA',
    recommendationEmpty: 'Nessun riepilogo ancora scritto.',
    kpisTitle: 'KPI',
    chartTitle: 'Vitalità e attività durante il pilot',
    chartCurrent: 'Attuale',
    noData: 'Nessun dato ancora.',
    participantCount: '{{count}} partecipanti',
    evaluationsTitle: 'Conclusioni e raccomandazioni',
    conclusionsTitle: 'Conclusioni',
    recommendationsListTitle: 'Raccomandazioni',
    evaluationsEmpty: 'Nessuna valutazione ancora registrata.',
    evaluationPhase: 'Fase',
    evaluationConclusions: 'Conclusioni',
    evaluationRecommendations: 'Raccomandazioni',
    decisionTitle: 'Decisione',
    scaleRequiresCompleted:
      "L'estensione è possibile solo dopo il completamento della valutazione finale.",
  },
  actions: {
    new: 'Nuovo pilot',
    cancel: 'Annulla',
    save: 'Salva',
    edit: 'Modifica',
    addEvaluation: 'Aggiungi valutazione',
    extend: 'Estendi',
    scale: 'Estendi su larga scala',
  },
};
